import { ClassEnum } from '@/constants/enum';
import styled from 'styled-components';

interface IProps {
  customCss?: string;
  lightView?: boolean;
}

export const CustomHeading = styled.div<IProps>`
  display: flex;
  gap: 4px;
  color: #fff;
`;

export const CustomButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  .Polaris-Select {
    .Polaris-Text--root {
      color: white;
    }

    .Polaris-Icon__Svg {
      fill: white;
    }
  }

  .Polaris-Select__Backdrop {
    background-color: black !important;
  }

  .Polaris-Select__SelectedOption {
    display: none;
  }

  .Polaris-Select__Content {
    min-height: fit-content;
    padding: 2px;
    height: 100%;
  }
`;

export const CustomStyled = styled.div<IProps>`
  #ot-dingdoong-root-cart-drawer {
    max-height: 510px;
    overflow: auto;
  }

  #ot-dingdoong-root-cart-drawer::-webkit-scrollbar {
    width: 8px;
  }

  #ot-dingdoong-root-cart-drawer::-webkit-scrollbar-track {
    background: transparent;
  }

  #ot-dingdoong-root-cart-drawer::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
  }

  .ot-dingdoong-root-cart-drawer-custom::-webkit-scrollbar-thumb:hover {
    background: #999;
  }

  .ot-dingdoong-root-cart-drawer-custom::-webkit-scrollbar-thumb:active {
    background: #666;
  }

  /* Thay đổi màu sắc khi chế độ lightView = false (Dark Mode) */
  /* ${({ lightView }) =>
    !lightView &&
    `
    #fulfillment-method-label {
      color: #ffffff !important;
    }

    .${ClassEnum.PickupLabel},
    .${ClassEnum.TimePickerLabel},
    .${ClassEnum.DayPickerLabel},
    .${ClassEnum.DeliveryLabel} {
      color: #ffffff !important;
    }

    .${ClassEnum.PickupLocationList} .${ClassEnum.PickupLocationItem} {
      color: #ffffff;
    }
    
    .ot-dingdoong-root-cart-drawer-custom::-webkit-scrollbar-thumb {
      background: #555;
    }
    
    .ot-dingdoong-root-cart-drawer-custom::-webkit-scrollbar-thumb:hover {
      background: #777;
    }
  `} */
  
  ${(props) => props.customCss}
`;
